/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { localizationStrSchema } from "./localizationStrSchema.ts";

export const comboSizeSchema = z.object({
	id: z.uuid(),
	name: z.string(),
	alt_name: z.string(),
	price: z.number().nullish(),
	is_default: z.boolean(),
	icon_color: z.string(),
	size_image: z.string().nullable(),
	weight: z.number().nullable(),
	measure_unit: z.string().nullable(),
	fat_amount: z.number().nullable(),
	proteins_amount: z.number().nullable(),
	carbohydrates_amount: z.number().nullable(),
	energy_amount: z.number().nullable(),
	base_price: z.number().nullable().describe("Цена размера без акции для зачёркивания, null — акции нет."),
	discount_percent: z.int().nullable().describe("Процент скидки по акции для плашки, null — акции нет."),
	loc_name: localizationStrSchema.describe("Util serializer for representation in swagger"),
	loc_alt_name: localizationStrSchema.describe("Util serializer for representation in swagger"),
	original_price: z.number(),
	price_modification: z.number(),
});
